import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-privacy-content',
  standalone: true,
  imports: [],
  templateUrl: './privacy-content.component.html',
  styleUrl: './privacy-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivacyContentComponent {
  private readonly sanitizer = inject(DomSanitizer);
  public readonly privacyUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    'https://autotaxatiepartners.nl/privacyverklaring/'
  );
}
